import type { EditorState } from '../store/editorState';

export const getDomainSuggestions = (state: EditorState): string[] =>
  state.domainSuggestions.suggestions;

export const isDomainSuggestionsTurnedOff = (state: EditorState): boolean =>
  state.domainSuggestions.isDomainSuggestionsTurnedOff;
